import { createSlice  } from '@reduxjs/toolkit';


export interface ApplicationState  {
    isShowModalWallet: boolean,
    isConnectError : boolean,
    connectErrorMessage : string,
    blockNumber: { [chainId: number]: number }
}

const  initialState : ApplicationState  = {
    isShowModalWallet: false,
    isConnectError: false,
    connectErrorMessage : "",
    blockNumber: {},
}

export const appSlice = createSlice({
    name : 'application',
    initialState,
    reducers : {
        toggleWalletModal : (state) => {
            state.isShowModalWallet = !state.isShowModalWallet
            state.isConnectError = false
        },
        setConnectError : (state , action) => {
            const { payload } = action
            const { isConnectError , connectErrorMessage } = payload 
            state.isConnectError = isConnectError
            state.connectErrorMessage  = connectErrorMessage
        }

    }


}) //  end slice


export const {   toggleWalletModal , setConnectError } =  appSlice.actions;
export default appSlice.reducer;